export function productSectorsSwiper() {
    const swiperContainers = document.querySelectorAll('.product-sectors__slider.swiper');

    if (!swiperContainers.length || typeof Swiper === 'undefined') {
        return;
    }

    swiperContainers.forEach((swiperContainer) => {
        const section = swiperContainer.closest('.product-sectors');
        if (!section) return;

        const prevButton = section.querySelector('.product-sectors__arrow--prev');
        const nextButton = section.querySelector('.product-sectors__arrow--next');
        const swiperWrapper = swiperContainer.querySelector('.swiper-wrapper');
        
        if (!swiperWrapper) return;

        // Get all original slides
        const originalSlides = swiperWrapper.querySelectorAll('.swiper-slide');
        const slideCount = originalSlides.length;
        const hasAutoscroll = section.classList.contains('autoscroll');

        // If has autoscroll class but slides <= 4, remove the class
        if (hasAutoscroll && slideCount <= 4) {
            section.classList.remove('autoscroll');
        }

        // Check if autoscroll should be enabled (has class and slides > 4)
        const shouldAutoscroll = section.classList.contains('autoscroll') && slideCount > 4;

        // If autoscroll is enabled, ensure slides are a multiple of 4
        if (shouldAutoscroll) {
            const remainder = slideCount % 4;
            if (remainder !== 0) {
                // Clone 4 slides from first 4 slides to make it closer to a multiple of 4
                const slidesToClone = Math.min(4, slideCount);
                for (let i = 0; i < slidesToClone; i++) {
                    const clonedSlide = originalSlides[i].cloneNode(true);
                    swiperWrapper.appendChild(clonedSlide);
                }
            }
        }

        // Configure Swiper
        const swiperConfig = {
            slidesPerView: 4,
            slidesPerGroup: 4,
            spaceBetween: 16,
            loop: false,
            speed: 400,
            navigation: {
                nextEl: nextButton,
                prevEl: prevButton,
            },
            breakpoints: {
                320: {
                    spaceBetween: 16,
                    slidesPerView: 1,
                    slidesPerGroup: 1,
                },
                768: {
                    spaceBetween: 20,
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                },
                1024: {
                    spaceBetween: 20,
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                },
                1366: {
                    spaceBetween: 24,
                    slidesPerView: 4.5,
                    slidesPerGroup: 4,
                },
            },
        };

        // Add autoplay configuration if autoscroll is enabled
        if (shouldAutoscroll) {
            swiperConfig.autoplay = {
                delay: 3000,
                disableOnInteraction: false,
            };
            // Ensure slidesPerGroup is 4 for autoscroll at 1366px breakpoint to scroll 4 at a time
            swiperConfig.breakpoints[1366].slidesPerGroup = 4;
            // Also set slidesPerGroup to 4 at 1024px for autoscroll
            swiperConfig.breakpoints[1024].slidesPerGroup = 4;
        }

        new Swiper(swiperContainer, swiperConfig);
    });
}

